import { render } from "./OptionTwo.vue?vue&type=template&id=b5caf08e&scoped=true"
import script from "./OptionTwo.vue?vue&type=script&lang=js"
export * from "./OptionTwo.vue?vue&type=script&lang=js"

import "./OptionTwo.vue?vue&type=style&index=0&id=b5caf08e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5caf08e"]])

export default __exports__